import React, { useRef, useEffect, useState } from 'react';
//import './App.css';
import useDeepCompareEffect from 'use-deep-compare-effect'
import { getEnvVariable } from '../../../modules/environmentalList';
import { Dialog, DialogTitle, Fab, IconButton } from '@material-ui/core';
import { Close, MapOutlined } from '@material-ui/icons';
import FullscreenIcon from '@material-ui/icons/Fullscreen';

export default function MapOpenNewBoxIframe(props) {
    const frameView = useRef(null);
    const [reload, setReload] = useState(false)
    const [setiframe, setIframe] = useState(false)
    const [fullScreen, setFullScreen] = useState(false)
    console.log(getEnvVariable('MapUI'))

    useEffect(() => {
        const messageHandler = (message) => {
            if ('http://localhost:8080/' + ``.includes(message.origin) || 'http://localhost:3000' + ``.includes(message.origin)) {
                if (frameView.current && frameView.current.contentWindow) {
                    console.log(message)
                    if (message.data === 'Initialized')
                        frameView.current.contentWindow.postMessage({ prop: { ...props } }, "*")
                }
            }
        }
        window.addEventListener('message', messageHandler)
    }, [])

    useDeepCompareEffect(() => {
        setTimeout(() => {
            if (frameView.current && frameView.current.contentWindow) {
                setReload(!reload)
                frameView.current.contentWindow.postMessage({ prop: { ...props } }, "*")
            }
        }, 400)

    }, [props])

    return (
        <>
            <Fab onClick={() => setIframe(!setiframe)} color='primary' size='small'><MapOutlined /></Fab>
            {setiframe &&
                <Dialog open={setiframe} onClose={() => setIframe(!setiframe)}
                    fullWidth={true}
                    maxWidth="lg"
                    fullScreen={fullScreen}
                >
                    <DialogTitle>
                        {props.title ? props.title : 'Map Editor'}
                        <IconButton style={{ position: 'absolute', right: '8px', top: '8px' }} onClick={() => setIframe(!setiframe)}>
                            <Close />
                        </IconButton>
                        <IconButton style={{ position: 'absolute', right: '50px', top: '8px' }} onClick={() => setFullScreen(!fullScreen)}>
                            <FullscreenIcon />
                        </IconButton>
                    </DialogTitle>

                    <div style={{ height: props.fullheight ? window.innerHeight : window.innerHeight - 50 }}>
                        {reload}
                        <iframe id='template-editor' src={getEnvVariable('MapUI') + ``} ref={frameView}
                            width="100%"
                            height="100%"
                            title='Map Editor'
                            scrolling="auto">
                        </iframe>
                    </div>
                </Dialog>}
        </>)
}



